import { useContext } from 'react';
import { StoreContext } from '@src/Contexts/StoreContext';

export const useJWTToken = () => {
    const { auth } = useContext(StoreContext);
    const { accessToken: token } = auth;

    return token;
};
